import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import React from "react";

const Loader = () => {
    return (
        <Box sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <CircularProgress/>
        </Box>
    );
}

export default Loader;